import React from 'react';
import { CircleCheckBigIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/landing';
type CTAButtonProps = {
  label: string;
  id?: string;
  microcopy?: string;
};
export function CTAButton({
  label,
  id,
  microcopy
}: CTAButtonProps) {
  return <div className="mx-auto w-full max-w-xl" data-id="element-31" data-mp="2kwbozxpkf0h8">
      <a id={id} href={CHECKOUT_URL} className="flex w-full items-center justify-center gap-3 rounded-2xl bg-cta px-5 py-5 text-center text-[17px] font-black uppercase leading-snug tracking-wide text-white shadow-[0_12px_28px_-10px_rgba(30,158,85,0.75)] transition-[transform,background-color] duration-150 ease-out hover:bg-cta-dark focus:outline-none focus-visible:ring-4 focus-visible:ring-cta/40 active:scale-[0.98] sm:text-xl" data-id="element-32" data-mp="2fyjvx0d6p8bg">
        <CircleCheckBigIcon className="h-6 w-6 shrink-0" aria-hidden="true" data-id="element-33" data-mp="3cpual1a95qob" />
        <span data-id="element-34" data-mp="3cnrlqkku63l6">{label}</span>
      </a>
      {microcopy && <p className="mt-3 text-center text-sm font-semibold leading-relaxed text-muted" data-id="element-35" data-mp="38p2064pn9fqg">{microcopy}</p>}
    </div>;
}